import { Circle } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { CalendarRange } from 'components/events-list/calendar-multi';
import { EventFilterButton } from 'components/events-list/event-filter-button';
import { EventsPaginatedAvailabilityFilterSelector } from 'components/events-list/events-paginated-availability-filter-selector';
import { EventsPaginatedDateRangeFilterSelector } from 'components/events-list/events-paginated-date-range-filter-selector';
import { EventsPaginatedDayFilterSelector } from 'components/events-list/events-paginated-day-filter-selector';
import { EventsPaginatedTicketsFilterSelector } from 'components/events-list/events-paginated-tickets-filter-selector';
interface EventsPaginatedFiltersProps {
  dateRange: CalendarRange;
  setDateRange: (range: CalendarRange) => void;
  showDateRangeFilter: boolean;
  earliestEventDate?: Date | null;
  ticketCount: number | null;
  setTicketCount: (ticketCount: number | null) => void;
  days: string | null;
  setDays: (day: string | null) => void;
  daysFilterOptions: {
    value: string | null;
    label: React.ReactNode;
  }[];
  showDayFilter: boolean;
  availability: string | null;
  setAvailability: (availability: string | null) => void;
  availabilityFilterOptions: {
    value: string | null;
    label: React.ReactNode;
    icon: React.ReactNode | null;
  }[];
  showAvailabilityFilter: boolean;
  specialOffersOnly: boolean;
  setSpecialOffersOnly: (specialOffersOnly: boolean) => void;
  hasSpecialOffer: boolean;
  clearFilters?: () => void;
}
export const EventsPaginatedFilters = ({
  dateRange,
  setDateRange,
  showDateRangeFilter,
  earliestEventDate,
  ticketCount,
  setTicketCount,
  days,
  setDays,
  daysFilterOptions,
  showDayFilter,
  availability,
  setAvailability,
  availabilityFilterOptions,
  showAvailabilityFilter,
  specialOffersOnly,
  setSpecialOffersOnly,
  hasSpecialOffer,
  clearFilters
}: EventsPaginatedFiltersProps) => {
  const hasActiveFilter = !!days || !!availability || specialOffersOnly || dateRange[0] !== null || ticketCount !== null;
  return <Stack direction={'row'} spacing={1} sx={{
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 1,
    mb: 2
  }}>
      {showDateRangeFilter && <EventsPaginatedDateRangeFilterSelector dateRange={dateRange} setDateRange={setDateRange} earliestEventDate={earliestEventDate} />}
      <EventsPaginatedTicketsFilterSelector ticketCount={ticketCount} setTicketCount={setTicketCount} />
      {showDayFilter && <EventsPaginatedDayFilterSelector days={days} setDays={setDays} daysFilterOptions={daysFilterOptions} />}
      {showAvailabilityFilter && <EventsPaginatedAvailabilityFilterSelector availability={availability} setAvailability={setAvailability} availabilityFilterOptions={availabilityFilterOptions} />}
      {hasSpecialOffer && <EventFilterButton clearable={specialOffersOnly} active={false} label={<FormattedMessage id="offer.specialOffer" defaultMessage={[{
      "type": 0,
      "value": "Special offer"
    }]} />} action={() => setSpecialOffersOnly(!specialOffersOnly)} onClear={() => setSpecialOffersOnly(false)} customEndIcon={<Circle sx={{
      width: 16,
      height: 16,
      color: 'primary.main'
    }} />} />}
      <Box sx={{
      flexGrow: 1
    }} />
      {clearFilters && hasActiveFilter && <Button variant="contained" color="monochrome" onClick={() => clearFilters()} sx={{
      '&:hover': {
        borderColor: 'primary.dark'
      }
    }}>
          <FormattedMessage id="event.filter.clear" defaultMessage={[{
        "type": 0,
        "value": "Clear filters"
      }]} />
        </Button>}
    </Stack>;
};